import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Shimmer, ShimmerElementType } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';

const getStyles = () => ({
  shimmerWrapper: {
    height: '100%',
    padding: '30px 0',
    background: '#fff',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    borderRadius: '2px',
    '& .header-shimmer': {
      margin: '20px 0',
    },
    '& .option-container': {
      width: 500,
      display: 'flex',
      justifyContent: 'space-between',
      '& .option-shimmer': {
        display: 'inline-block',
        width: 240,
        height: 300,
        marginBottom: 18,
      },
    },
  },
  'shimmerWrapper-m': {
    '& .option-container': {
      width: 280,
      flexDirection: 'column',
      '& .option-shimmer': {
        width: 280,
        height: 250,
      },
    },
  },
  'shimmerWrapper-s': {
    '& .option-container': {
      width: 240,
      flexDirection: 'column',
      '& .option-shimmer': {
        width: 240,
        height: 200,
      },
    },
  },
});

export const CampaignModeStepShimmer = () => {
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  const { optionHeight, optionWidth } = useMemo(() => {
    if (displayMode === 's') {
      return {
        optionHeight: 200,
        optionWidth: 240,
      };
    }
    if (displayMode === 'm') {
      return {
        optionHeight: 250,
        optionWidth: 280,
      };
    }
    return {
      optionHeight: 300,
      optionWidth: 240,
    };
  }, [displayMode]);

  const optionShimmer = useMemo(() => (
    <Shimmer
      className="option-shimmer"
      shimmerElements={[{ type: ShimmerElementType.line, height: optionHeight, width: optionWidth }]}
    />
  ), [optionHeight, optionWidth]);

  return (
    <div className={classNames('shimmer-wrapper', classes.shimmerWrapper, classes[`shimmerWrapper-${displayMode}`])}>
      <Shimmer
        className="icon-shimmer"
        shimmerElements={[{ type: ShimmerElementType.line, height: 44, width: 50 }]}
      />
      <Shimmer
        className="header-shimmer"
        shimmerElements={[{ type: ShimmerElementType.line, height: 22, width: displayMode === 's' ? 240 : 280 }]}
      />
      <div className="option-container">
        {optionShimmer}
        {optionShimmer}
      </div>
    </div>
  );
};
